// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { crewRoute, crewRouteAbsolute } from '../roleRoutes/crew';
// Styles, images, icons
import { icons } from '~/assets';

export const privateCrewRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: crewRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Dashboard
  {
    path: crewRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: crewRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: crewRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: crewRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: crewRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.crm}${crewRoute.leads}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.crm}${crewRoute.leads}${crewRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: crewRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.crm}${crewRoute.clients}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.crm}${crewRoute.clients}${crewRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: crewRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: crewRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${crewRoute.base}${crewRoute.jobs}${crewRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: crewRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: crewRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: crewRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: crewRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.quotes}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: crewRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${crewRoute.base}${crewRoute.order}${crewRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.order}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: crewRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: crewRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.invoice}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${crewRoute.base}${crewRoute.quotes}${crewRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: crewRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: crewRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: crewRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: crewRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: crewRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.inventory}${crewRoute.product}${crewRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.inventory}${crewRoute.product}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.inventory}${crewRoute.package}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.inventory}${crewRoute.package}${crewRoute.commonDetail}${crewRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${crewRoute.base}${crewRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.reports}${crewRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: crewRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: crewRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: crewRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: crewRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: crewRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: crewRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: crewRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: crewRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${crewRoute.base}${crewRoute.purchaseOrder}${crewRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: crewRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: crewRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.settings}${crewRoute.users}${crewRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: crewRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.settings}${crewRoute.users}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: crewRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.settings}${crewRoute.venue}${crewRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: crewRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.settings}${crewRoute.venue}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: crewRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: crewRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${crewRoute.base}${crewRoute.settings}${crewRoute.roleManagement}${crewRoute.commonDetail}${crewRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: crewRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: crewRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: crewRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: crewRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
